import styled from 'styled-components';
import ButtonIcon from 'components/ButtonIcon';
import ListTile from 'components/ListTile';
import Picklist from 'components/Picklist';
import { PURPLE_500 } from '../../../../constants';

export const Container = styled.div`
    position: relative;
    display: flex;
    gap: 0.5rem;
    margin-top: 0.25rem;
    overflow: hidden;
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;

    svg {
        width: 1rem !important;
        height: 1rem !important;
        font-size: 1rem !important;
    }
`;

export const StyledPicklist = styled(Picklist)`
    position: absolute;
    width: 250px;
    height: 0px;
    right: 0px;
    top: 1.5rem;
    overflow: hidden;

    input {
        position: absolute;
        height: 0px;
    }
`;

export const StyledListTile = styled(ListTile)<{ isPrimary?: boolean }>`
    width: 100%;
    & > div:last-child {
        line-height: unset;

        & > span:last-child {
            font-size: 0.75rem;
            padding-left: 0.55rem;
        }
    }
    & > div:first-child {
        ${(props) => props.isPrimary && `
            color: ${PURPLE_500};
        `}
    }
`;
